/*================Name validation Optional Directive
    ==========================================*/
/*
  *
  * place data-valid-name inside the input field
  * <input type="text" id="" name="" data-valid-name-optional>
  *
  */
 angular
 .module('vppApp')
 .directive('validNameOptional', function(){
   return {
     restrict: "A",

     require: "ngModel",

     link: function(scope, element, attributes, ngModel) {
       ngModel.$validators.validName = function(ngModelValue) {

        if(/^(?![^,]*,[^,]*,)\x20?(?:[a-zA-Z'-]+\x20?)*$/.test(ngModelValue)){
         return true
       }
       return false
     };
   }
 };
});